import PropTypes from "prop-types";

const hasReportErrors = (errors) => {
  if (!errors) return false;
  if (Array.isArray(errors)) return errors.length > 0;

  return Object.values(errors).some(
    (value) => Array.isArray(value) && value.length > 0
  );
};

const formatRowData = (data) => {
  if (!data || typeof data !== "object") return "-";

  return Object.entries(data)
    .map(([key, value]) => `${key.replace(/_/g, " ")}: ${value ?? "-"}`)
    .join(", ");
};

const ErrorRowsTable = ({ title, rows, tableClass }) => {
  if (rows.length === 0) return null;

  return (
    <div className="mb-4">
      <h6 className="text-dark fw-semibold mb-2">{title}</h6>
      <div className="table-responsive">
        <table className="table table-sm table-bordered align-middle mb-0">
          <thead className={tableClass}>
            <tr>
              <th>Row Number</th>
              <th>Error</th>
              <th>Details</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((item, index) => (
              <tr key={`${title}-${index}`}>
                <td>{item.row_number ?? "-"}</td>
                <td>{item.Error || "-"}</td>
                <td>{formatRowData(item.data)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const SalaryImportReport = ({ message, errors }) => {
  const showErrors = hasReportErrors(errors);
  const duplicatesInExcel = errors?.duplicates_in_excel || [];
  const duplicatesInDb = errors?.duplicates_in_db || [];

  return (
    <div className="mt-4">
      <div
        className={`alert ${showErrors ? "alert-warning" : "alert-success"} mb-3`}
        role="alert"
      >
        <strong>{showErrors ? "Import completed with warnings" : "Import successful"}</strong>
        <div className="mt-1">{message}</div>
      </div>

      {!showErrors && (
        <p className="text-success mb-0">
          All rows were validated and processed without any duplicates or errors.
        </p>
      )}

      <ErrorRowsTable
        title="Duplicates in Excel"
        rows={duplicatesInExcel}
        tableClass="table-warning"
      />

      <ErrorRowsTable
        title="Issues found in Database"
        rows={duplicatesInDb}
        tableClass="table-info"
      />
    </div>
  );
};

SalaryImportReport.propTypes = {
  message: PropTypes.string,
  errors: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default SalaryImportReport;
